import '@aws-amplify/ui-react/styles.css';
import React, {useEffect, useState} from 'react';
import Amplify, { Auth, Hub } from 'aws-amplify';
import Routes from './routes';
import ThemeCustomization from './themes';
import ScrollTop from './components/ScrollTop';
import ProtectedRoute from './routes/ProtectedRoute';
import IdleTimeout from './components/IdleTimeout';

const awsconfig = {
  aws_cognito_region: process.env.REACT_APP_REGION,
  aws_project_region: process.env.REACT_APP_REGION,
  aws_user_pools_id: process.env.REACT_APP_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
      domain: process.env.REACT_APP_OAUTH_DOMAIN,
      scope: [
          "aws.cognito.signin.user.admin",
          "email",
          "openid",
          "phone",
          "profile"
      ],
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN_OUT,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_IN_OUT,      
      responseType: "code"
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [
          "REQUIRES_LOWERCASE,",
          "REQUIRES_UPPERCASE",
          "REQUIRES_NUMBERS",
          "REQUIRES_SYMBOLS"
      ]
  },
  aws_cognito_verification_mechanisms: []
};
Amplify.configure(awsconfig)

function App() {

  //const [testAPI, setTestAPI] = React.useState("");

  const [user, setUser] = useState(null);
  //const [userName, setUserName] = useState(null);

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      console.log(event)
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser().then(userData => setUser(userData));
          break;
        case 'signOut':
          setUser(null);
          //setUserName(null);
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          console.log('Sign in failure', data);
          break;
      }
    });

    getUser().then(userData => setUser(userData));
  }, []);

  function getUser() {
    return Auth.currentAuthenticatedUser()
    .then(userData => userData)
    .catch(() => {
      //console.log('Not signed in')
      Auth.federatedSignIn();
    });
  }

  const handleLogout = async () => {
      await Auth.signOut();
  };

  return (
    <div>
      {user &&
        (
          <ThemeCustomization>
            <ScrollTop>
              <IdleTimeout isAuthenticated={user != null} onLogout={handleLogout} />
              <Routes />
            </ScrollTop>
          </ThemeCustomization>
        )
        // :
        // (
        //   <button onClick={() => Auth.federatedSignIn()}>Login</button>
        // )
      }
    </div>
  );
}

export default App;
